// Lifecycle
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
export function postResizeMessage(data) {
    postMessage(_object_spread({
        type: "PD_PLACEMENT_RESIZE"
    }, data));
}
export function postCartCheckoutClicked(data) {
    postMessage(_object_spread({
        type: "PD_CART_CHECKOUT_BUTTON_CLICKED"
    }, data));
}
export function postCloseCartClicked(data) {
    postMessage(_object_spread({
        type: "PD_CART_CLOSE_BUTTON_CLICKED"
    }, data));
}
// Checkout
export function postCheckoutLoaded(data) {
    postMessage(_object_spread({
        type: "CHECKOUT_LOADED"
    }, data));
}
export function postPreorderCheckoutStep(data) {
    postMessage(_object_spread({
        type: "PREORDER_CHECKOUT_STEP"
    }, data));
}
export function postPreorderCheckoutSubmitted(data) {
    postMessage(_object_spread({
        type: "PREORDER_CHECKOUT_SUBMITTED"
    }, data));
}
export function postPreorderCreated(data) {
    postMessage(_object_spread({
        type: "PREORDER_CREATED"
    }, data));
}
export function postOrderCreated(data) {
    postMessage(_object_spread({
        type: "ORDER_CREATED"
    }, data));
}
export function postPreorderFailed(data) {
    postMessage(_object_spread({
        type: "PREORDER_FAILED"
    }, data));
}
export function postClosedMessage(data) {
    postMessage(_object_spread({
        type: "CLOSED"
    }, data));
}
// Status
export function postCartCleared() {
    postMessage({
        type: "CART_CLEARED"
    });
}
export function trackOrderCreated(checkoutViewModel) {
    postOrderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "order"
    }));
}
export function trackPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "preorder"
    }));
}
export function trackCombinedPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toCombinedTrackingOrderObject({
        checkoutViewModel: checkoutViewModel
    }));
}
export function postGoToHomepage() {
    postMessage({
        type: "GO_TO_HOME_PAGE"
    });
}
/**
 * Used to build the tracking order object from checkoutViewModel
 * @param { Object } args
 * @param { Object } args.checkoutViewModel
 * @param { ('order'|'preorder') } args.type='preorder'
 * @returns Object
 */ export function toTrackingOrderObject() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, checkoutViewModel = ref.checkoutViewModel, _type = ref.type, type = _type === void 0 ? "preorder" : _type;
    var order = type === "preorder" ? checkoutViewModel.preorder : checkoutViewModel.order;
    var lineItems = type === "preorder" ? checkoutViewModel.preorder.lineItems : checkoutViewModel.order.lineItems;
    return {
        reference: order.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: lineItems[0].sku.id,
        lineItem: {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: order.total.amount,
            currency: order.total.currency
        },
        tax: order.tax,
        shipping: order.shipping,
        discountCode: order.discountCode
    };
}
export function toCombinedTrackingOrderObject() {
    var checkoutViewModel = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).checkoutViewModel;
    return {
        reference: checkoutViewModel.preorder.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        lineItems: checkoutViewModel.combinedPreorderOrder.lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties,
                purchaseType: lineItem.purchaseType
            };
        }),
        total: checkoutViewModel.combinedPreorderOrder.total,
        tax: checkoutViewModel.combinedPreorderOrder.tax,
        shipping: checkoutViewModel.combinedPreorderOrder.shipping,
        discountCode: checkoutViewModel.combinedPreorderOrder.discountCode
    };
}
function postMessage(data) {
    window.parent.postMessage(data, "*");
}
